<template>
  <div class="error-container">
    <span class="code">{{ $t('message.errores.404.codigo') }}</span
    >{{ $t('message.errores.404.detalle') }}
    <p class="small">Se redireccionará a la página de inicio...</p>
  </div>
</template>

<script>
export default {
  mounted() {
    this.redirect();
  },
  methods: {
    redirect() {
      setTimeout(() => {
        this.$router.push({ name: 'home' });
      }, 5000);
    }
  }
};
</script>
